import React from "react";
import { useState } from "react";
import { convertArrayToCSV } from "convert-array-to-csv";
import FileSaver from "file-saver";
import { DropdownDate } from "react-dropdown-date";
import { useSelector } from "react-redux/es/exports";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "./taload.css";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { isSuperAdmin, isUserAdmin } from "../../utils/comman/Common";

const Taloadrequest = () => {
  const newDate = new Date();
  let currentYear = newDate.getFullYear();  
  const requesterId = useSelector((state) => state.selectedretailerReqesterReducer.requesterId);
  const [axiosInstance] = axiosinstances();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const e = JSON.parse(sessionStorage.getItem("token"));
  const [table, setTable] = useState([]);
  const [searched, setSearched] = useState("");
  const [pagecount, setpagecount] = useState(0);
  const [month, setMonth] = useState("select");
  const [monthind, setmonthind] = useState();
  const [year, setYear] = useState(currentYear);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 10,
  });
  //console.log("monthind", monthind);
  let monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handlemonth = (month) => {
    setMonth(month);

    const indexofarray = monthNames.findIndex((element, index) => {
      if (element === month) {
        return true;
      }

      return false;
    });

    const monthindex = indexofarray + 1;
    // setMonth(monthindex);
    setmonthind((monthindex) => {
      return monthindex;
    });
    setmonthind(monthindex);

    monthfilterfirst(monthindex);
  };

  const monthfilterfirst = async (monthind) => {
    setmonthind((monthind) => {
      return monthind;
    });
    const callingsearchapi = await monthapi(monthind);
    //setsearch("")
    setTable(() => callingsearchapi);
  };

  const monthapi = async (monthind) => {
    return await axiosInstance
      .get(
        `/api/v1/virtual-balance/claim/list/${
          isUserAdmin(id) ? "all" : id
        }/${year}/${monthind}`,
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            time: new Date(),
          },
        }
      )
      .then((response) => {
        if (response) {
          const { data } = response;

          return data;
        }
        return false;
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
  };

  const handlepageclick = () => {};
  const Taloadanswer = useSelector(
    (state) => state.gettaloadresucer?.gettaloadlist
  );

  const pageHandler = (page) => {
    //console.log("page", page);
  };
  useEffect(() => {
    setTable(Taloadanswer);
  }, [Taloadanswer]);

  const indexOfLastPost =
    paginationDetails.currentPage * paginationDetails.postsPerPage;

  const indexOfFirstPost = indexOfLastPost - paginationDetails.postsPerPage;
  // const dashBoard = () => {
  //   history.push("/dashboard");
  //   history.go();
  // };
  const paginatedTable = () => {
    const searchedResult =
      table !== undefined &&
      table !== "" &&
      table.filter((val, index) => {
        if (searched === "") {
          return val;
        } else if (val.utr !== undefined && val.utr.includes(searched)) {
          //console.log(index);
          return val;
        } else {
          return [];
        }
      });
    if (searched === "" && table !== undefined) {
      return searchedResult.slice(indexOfFirstPost, indexOfLastPost);
    } else if (!searchedResult) {
      return [];
    } else {
      return searchedResult;
    }
  };

  //console.log("paginatedTable", paginatedTable());
  const handleSearch = () => {
    const getSearch = table.filter((val) => val.utr === searched);
    setTable(getSearch);
  };
  const onExportData = () => {
    const csv = convertArrayToCSV(table);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, "talist.csv");
  };
  const clearSearch = () => {
    setSearched("");
    // handalpageclick(1);
    monthfilterfirst(monthind);
  };
  const getRejectApprove = async (check, claimId) => {
    const url =
      check === "approve"
        ? `/api/v1/virtual-balance/claim/update/${claimId}?status=APPROVED&reason=${id}`
        : `/api/v1/virtual-balance/claim/update/${claimId}?status=REJECTED&reason=${id}`;
    const response = await axiosInstance
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            "msgType" : "ORDER_HISTORY",
            "channel" :  "ADMIN",
            "requesterId" : requesterId,
            "time" : new Date()
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        //console.log(err);
      });
    if (response) {
      //console.log("resp--", response);
      if (check === "approve") {
        toast.success("Approve Successfully");
      } else if (check === "reject") {
        toast.error("Rejected !!!");
      }

      monthfilterfirst(monthind);
      // return response.data;
    }
    return false;
  };
  const rejectOrder = (id) => {
    getRejectApprove("reject", id);
  };

  const approveOrder = (id) => {
    getRejectApprove("approve", id);
  };
  return (
    <React.Fragment>
      <div class="mid">
        <div class="container-fluid">
          <div class="head">
            <h3>TA Load Request</h3>
            <div>
              <DropdownDate
                onMonthChange={(month) => handlemonth(month)}
                onYearChange={(year) => {
                  setYear(year);
                }}
                defaultValues={{
                  year: year,
                  month: month,
                }}
              />
            </div>
            <div class="headsearch">
              <div class="input-group">
                <input
                  type="text"
                  value={searched}
                  class="form-control"
                  placeholder="Search client..."
                  onChange={(e) => setSearched(e.target.value)}
                />
                <button
                  onClick={handleSearch}
                  class="btn search"
                  type="button"
                  id="txnsrch"
                >
                  search
                </button>
                <button
                  style={{ background: "#FF8D33", marginLeft: "3px" }}
                  class="btn delete"
                  // disabled={search.length <= 3}
                  type="button"
                  onClick={clearSearch}
                >
                  clear
                </button>
              </div>
            </div>
          </div>

          <div class="reqlist">
            {paginatedTable().map((data) => {
              return (
                <div
                  class={`loadlist txncard ${
                    data.status === "APPROVED"
                      ? "success grbg"
                      : `${
                          data.status === "REJECTED"
                            ? "failed rdbg"
                            : "pending ylbg"
                        }`
                  }`}
                  key={data.id}
                >
                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-12 col-xl-1">
                      <div class="tatxt">
                        <p>Txn Date</p>
                        <h5>{data.txnDate}</h5>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-12 col-xl-2">
                      <div class="tatxt">
                        <p>Bank Name</p>
                        <h5>{data.bank}</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-12 col-xl-3">
                      <div class="tatxt">
                        <p>TXN ID</p>
                        <h5>{data.utr}</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-12 col-xl-2">
                      <div class="tatxt">
                        <p>Entity Id</p>
                        <h5>{data.entityId}</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-12 col-xl-1">
                      <div class="tatxt">
                        <p>TXN Mode</p>
                        <h5>{data.txnMode}</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-12 col-xl-1">
                      <div class="tatxt">
                        <p>Claim Amount</p>
                        <h4>₹{data.amount}</h4>
                      </div>
                    </div>
                    {data.status == null && isSuperAdmin(id) && isUserAdmin(id) ? (
                      <div class="col-md-2">
                        <div class="tatxt1">
                          <button
                            type="button"
                            class="btn rdbtn mr-2"
                            onClick={() => rejectOrder(data.id)}
                          >
                            Reject
                          </button>
                          <button
                            type="button"
                            class="btn grbtn"
                            onClick={() => approveOrder(data.id)}
                          >
                            Approve
                          </button>
                        </div>
                      </div>
                    ) : data.status !== null ? (
                      <div class="col-md-2 aprv">
                        <h4>
                          {" "}
                          <span
                            class={`${
                              data.status === "APPROVED" ? "success" : "failed"
                            }`}
                          >
                            {data.status}
                          </span>
                        </h4>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              );
            })}
            <div class="pager">
              <div>
                {
                  // checkPermission('merchantExport') &&
                  paginatedTable()?.length >= 1 && searched == "" && (
                    <p>
                      Showing 1 to{" "}
                      {table !== undefined && table.length < 10
                        ? table.length
                        : 10}{" "}
                      of {table !== undefined && table.length} entries{" "}
                      <a href={"#"}>
                        {" "}
                        <button
                          type="button"
                          onClick={onExportData}
                          class="lbbtn"
                        >
                          Export
                        </button>
                      </a>
                    </p>
                  )
                }

                {table !== undefined && table.length > 10 && searched == "" && (
                  // <Pagination  postsPerPage={paginationDetails.postsPerPage} totalPosts={table.length} paginate={paginate} currentPage={paginationDetails.currentPage} />
                  <Pagination
                    className="pagination-bar"
                    currentPage={paginationDetails.currentPage}
                    totalCount={table !== undefined ? table.length : 0}
                    pageSize={paginationDetails.postsPerPage}
                    onPageChange={(page) => {
                      setPaginationDetails((prev) => {
                        return { ...prev, currentPage: page };
                      });
                      pageHandler(page);
                    }}
                  />
                )}
              </div>
            </div>
            {/* <div class="pager">
              <p>
                Showing 1 to 12 of 45 entries{" "}
                <button class="lbbtn" type="button">
                  Export
                </button>
              </p>
              <ul class="pagination pagination-sm">
                <li class="page-item">
                  <a class="page-link" href="#">
                    Prev
                  </a>
                </li>
                <li class="page-item active">
                  <a class="page-link" href="#">
                    1
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    2
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    3
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    4
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    Next
                  </a>
                </li>
              </ul>
            </div> */}

            {/* <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
            //   pageCount={pagecount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
            //   onPageChange={handlepageclick}
              container-className={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
            //   previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            /> */}
          </div>
        </div>

        {/* <ReactPaginate
        previousLabel={"prev"}
        nextLabel={"next"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={10}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlepageclick}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}/> */}
      </div>

      {/* <ReactPaginate
        previousLabel={"prev"}
        nextLabel={"next"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={10}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlepageclick}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}/> */}

      {/* <div
        class="modal fade"
        id="approved"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="clntadded">
                <i class="succuss"></i>
                <h5>Claim amount has been approved successfully</h5>
                <p>Amount: ₹ 34,234.00</p>
                <button
                  class="btn btn-primary"
                  type="button"
                  onclick="window.location.href='ta-request.html'"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="reject"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="clntadded">
                <i class="reject"></i>
                <h5>Claim amount reject</h5>
                <p>Amount: ₹ 34,234.00</p>
                <div class="formrow">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control"
                      id="com"
                      placeholder="Comment"
                    />
                    <label for="com">Comment</label>
                  </div>
                </div>
                <button
                  class="btn btn-primary"
                  type="button"
                  onclick="window.location.href='ta-request.html'"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
};

export default Taloadrequest;
